import { cn } from './cn.ts';

/** A person's initials on a soft disc (shadcn's avatar fallback; members carry no photo). `none` for someone with no name to show. */
export function UiAvatar({ initials, size = 'default', className }: { readonly initials: string; readonly size?: 'default' | 'large'; readonly className?: string }) {
  return (
    <span
      data-slot="avatar"
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-chip bg-sunk font-bold text-ink-2 uppercase select-none',
        size === 'large' ? 'size-s7 text-strong' : 'size-s6 text-caption',
        className,
      )}
    >
      {initials}
    </span>
  );
}

/** Splits a word into what a reader sees as characters, so an initial is never half of one. */
const first = new Intl.Segmenter();

/** A name's initials, two at most: "Aina Rahman" is AR, "Ravi" is R. */
export function initialsOf(name: string): string {
  const words = name.split(/\s+/).filter((word) => word !== '');
  return words
    .slice(0, 1)
    .concat(words.length > 1 ? words.slice(-1) : [])
    .map((word) => first.segment(word)[Symbol.iterator]().next().value?.segment ?? '')
    .join('');
}
